import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=152b30bf&scoped=true"
import script from "./Communications.vue?vue&type=script&lang=ts"
export * from "./Communications.vue?vue&type=script&lang=ts"
import style0 from "./Communications.vue?vue&type=style&index=0&id=152b30bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b30bf",
  null
  
)

export default component.exports